import { Api } from 'utils';

class HomeService {

	static admin = {
		get: async (params?: any) => Api.createResponse('admin/home',params)
	}
}

export default HomeService;